/* ==========================================================================
   Sticky table of contents — sections/two-columns.liquid
   Builds the nav links client-side from [data-toc-entry] markers (each
   numbered advertorial-container renders its own marker with its own
   block.settings, since Shopify doesn't expose sibling theme-block
   settings server-side via section.blocks), then highlights whichever
   one is currently in view as the page scrolls.
   ========================================================================== */
(function () {
  function buildLinks(root) {
    var list = root.querySelector('[data-advertorial-toc-list]');
    if (!list) return [];

    var entries = Array.prototype.slice.call(document.querySelectorAll('[data-toc-entry]'));
    var links = [];

    entries.forEach(function (entry) {
      if (!entry.id) return;
      var link = document.createElement('a');
      link.href = '#' + entry.id;
      link.className = 'advertorial-toc__link';
      link.setAttribute('data-advertorial-toc-link', '');
      link.setAttribute('data-target', entry.id);
      link.textContent = entry.getAttribute('data-toc-label') || '';
      list.appendChild(link);
      links.push(link);
    });

    return links;
  }

  function init(root) {
    if (root.dataset.advertorialTocInit) return;
    root.dataset.advertorialTocInit = 'true';

    var links = buildLinks(root);
    if (!links.length) return;

    var targets = links
      .map(function (link) {
        var el = document.getElementById(link.getAttribute('data-target'));
        return el ? { link: link, el: el } : null;
      })
      .filter(Boolean);
    if (!targets.length) return;

    function setActive(activeLink) {
      links.forEach(function (link) {
        link.classList.toggle('is-active', link === activeLink);
      });
    }

    setActive(targets[0].link);

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var match = targets.filter(function (t) { return t.el === entry.target; })[0];
          if (match) setActive(match.link);
        });
      },
      { rootMargin: '-15% 0px -70% 0px', threshold: 0 }
    );

    targets.forEach(function (t) { observer.observe(t.el); });
  }

  function initAll() {
    document.querySelectorAll('[data-advertorial-toc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
